import React from "react";
import { Tabs, Card } from "antd";
import { Loader } from "../Loader/Loader";
import web1 from "../Assets/web1.png";
import web2 from "../Assets/web2.png";
import { motion } from "framer-motion";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const { Meta } = Card;
const Market = ({ loader, setCollapsed }) => {
  const screens = useBreakpoint()

  const items = [
    {
      key: "1",
      label: (
        <svg
          width="27"
          height="28"
          viewBox="0 0 27 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_60_13625)">
            <path
              d="M26.2512 1.10693H6.75128C6.3371 1.10693 6.00119 1.44284 6.00119 1.85703V24.357C5.99844 25.1708 5.72845 25.9616 5.23242 26.607H23.2514C25.3215 26.6048 26.9991 24.9272 27.0013 22.8568V1.85703C27.0013 1.44284 26.6654 1.10693 26.2512 1.10693ZM21.7512 20.6068H11.2513C10.8371 20.6068 10.5012 20.2712 10.5012 19.857C10.5012 19.4428 10.8371 19.1069 11.2513 19.1069H21.7512C22.1654 19.1069 22.5013 19.4428 22.5013 19.857C22.5013 20.2712 22.1654 20.6068 21.7512 20.6068ZM21.7512 16.1068H11.2513C10.8371 16.1068 10.5012 15.7712 10.5012 15.357C10.5012 14.9428 10.8371 14.6069 11.2513 14.6069H21.7512C22.1654 14.6069 22.5013 14.9428 22.5013 15.357C22.5013 15.7712 22.1654 16.1068 21.7512 16.1068ZM21.7512 11.6068H11.2513C10.8371 11.6068 10.5012 11.2712 10.5012 10.857C10.5012 10.4428 10.8371 10.1069 11.2513 10.1069H21.7512C22.1654 10.1069 22.5013 10.4428 22.5013 10.857C22.5013 11.2712 22.1654 11.6068 21.7512 11.6068ZM21.7512 7.10684H11.2513C10.8371 7.10684 10.5012 6.77121 10.5012 6.35703C10.5012 5.94284 10.8371 5.60693 11.2513 5.60693H21.7512C22.1654 5.60693 22.5013 5.94284 22.5013 6.35703C22.5013 6.77121 22.1654 7.10684 21.7512 7.10684Z"
              fill="#91959E"
            />
            <path
              d="M3.75186 4.10706H0.752045C0.33786 4.10706 0.00195312 4.44269 0.00195312 4.85687V24.3571C0.00195312 25.5996 1.0094 26.6071 2.25195 26.6071C3.49451 26.6071 4.50195 25.5996 4.50195 24.3571V4.85687C4.50195 4.44269 4.16605 4.10706 3.75186 4.10706Z"
              fill="#91959E"
            />
          </g>
          <defs>
            <clipPath id="clip0_60_13625">
              <rect
                width="27"
                height="27"
                fill="white"
                transform="translate(0.00195312 0.333496)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      children: <div className="no-promo">Coming Soon</div>,
    },
    {
      key: "2",
      label: (
        <svg
          width="27"
          height="28"
          viewBox="0 0 27 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.502 0.333496C6.04549 0.333496 0.00195312 6.37762 0.00195312 13.8335C0.00195312 21.2894 6.04549 27.3335 13.502 27.3335C20.9584 27.3335 27.002 21.2888 27.002 13.8335C27.002 6.37821 20.9578 0.333496 13.502 0.333496ZM14.3192 19.8471V21.4098C14.3192 21.6536 14.1294 21.831 13.885 21.831H12.8434C12.599 21.831 12.4022 21.6536 12.4022 21.4098V19.9845C11.4434 19.9411 10.4764 19.7366 9.74435 19.4582C9.34779 19.3078 9.12689 18.883 9.23205 18.4718L9.40184 17.8102C9.46118 17.5782 9.61627 17.3843 9.82836 17.2756C10.0404 17.1652 10.2895 17.154 10.5122 17.2392C11.2096 17.5089 12.0332 17.7051 12.9127 17.7051C14.0325 17.7051 14.7991 17.2727 14.7991 16.4866C14.7991 15.7399 14.1705 15.2682 12.7159 14.7764C10.6133 14.0691 9.17331 13.0868 9.17331 11.1804C9.17331 9.45139 10.3971 8.09545 12.4891 7.68245V6.25719C12.4891 6.01338 12.6977 5.79483 12.9421 5.79483H13.9837C14.2281 5.79483 14.4073 6.01338 14.4073 6.25719V7.54438C15.322 7.58375 15.9823 7.71946 16.5346 7.89923C16.9523 8.03553 17.199 8.47321 17.0892 8.89973L16.94 9.49192C16.8818 9.71752 16.7326 9.90904 16.5281 10.0195C16.3237 10.1299 16.0822 10.1499 15.8613 10.0741C15.3596 9.90199 14.7051 9.74572 13.8756 9.74572C12.5984 9.74572 12.1854 10.2962 12.1854 10.8467C12.1854 11.4953 12.8733 11.9077 14.5436 12.5369C16.8818 13.3623 17.8212 14.4433 17.8212 16.2111C17.8206 17.96 16.5851 19.4546 14.3192 19.8471Z"
            fill="#91959E"
          />
        </svg>
      ),
      children: <div className="no-promo">Coming Soon</div>,
    },
    {
      key: "3",
      label: (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.141496 26.6601C0.289047 26.8725 0.531572 26.9999 0.791131 26.9999H26.2089C26.4684 26.9999 26.711 26.8725 26.8585 26.6601C27.0068 26.4469 27.0408 26.175 26.9497 25.9317C26.6415 25.1074 26.0652 24.3844 25.8311 24.1125C25.6813 23.9371 25.4619 23.8359 25.2309 23.8359H1.76909C1.53811 23.8359 1.31874 23.9371 1.16887 24.1125C0.934832 24.3844 0.358551 25.1074 0.0503182 25.9317C-0.0408068 26.175 -0.00684586 26.4469 0.141496 26.6601Z"
            fill="#91959E"
          />
          <path
            d="M3.16406 12.709H7.9629V22.2539H3.16406V12.709Z"
            fill="#91959E"
          />
          <path
            d="M11.127 12.709H15.8731V22.2539H11.127V12.709Z"
            fill="#91959E"
          />
          <path
            d="M19.0371 12.709H23.8359V22.2539H19.0371V12.709Z"
            fill="#91959E"
          />
          <path
            d="M1.71213 10.894C1.86063 11.0431 2.06729 11.127 2.27169 11.127C2.2718 11.127 2.27195 11.1268 2.27206 11.1268C2.27217 11.1268 2.27232 11.127 2.27243 11.1264H24.7276C24.7277 11.127 24.7278 11.1268 24.7279 11.1268C24.728 11.1268 24.7282 11.127 24.7283 11.127C24.9327 11.127 25.1394 11.0432 25.2879 10.894C25.4488 10.7331 26.6517 9.48037 26.9999 7.96289H0C0.34831 9.48037 1.55113 10.7331 1.71213 10.894Z"
            fill="#91959E"
          />
          <path
            d="M26.4951 6.38086L13.8523 0.0834127C13.6298 -0.0278042 13.3672 -0.0278042 13.1447 0.0834127L0.501953 6.38086H26.4951Z"
            fill="#91959E"
          />
        </svg>
      ),

      children: <div className="no-promo">Coming Soon</div>,
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          {screens.lg && <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.3 }}
          >
            <div className="display-5 p-20 trad-pos">
              <div className="side-title">Markets & Analysis</div>
              <div
                className="cursor nonea3"
                onClick={() => setCollapsed(true)}
                id="cs"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z"
                    fill="#82858E"
                    stroke="#82858E"
                    stroke-width="1.5294"
                  />
                </svg>
              </div>
            </div>
          </motion.div>}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.3 }}
            style={{ height: "100%" }}
          >
            <Tabs
              defaultActiveKey="1"
              items={items}
              onChange={onChange}
              className="promo-tab market"
              style={{ height: "100%" }}
            />
          </motion.div>
        </>
      )}
    </>
  );
};

export default Market;
